import { render, staticRenderFns } from "./BlindPlateList.vue?vue&type=template&id=49b89737&scoped=true"
import script from "./BlindPlateList.vue?vue&type=script&lang=js"
export * from "./BlindPlateList.vue?vue&type=script&lang=js"
import style0 from "./BlindPlateList.vue?vue&type=style&index=0&id=49b89737&prod&lang=scss"
import style1 from "./BlindPlateList.vue?vue&type=style&index=1&id=49b89737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b89737",
  null
  
)

export default component.exports